import styled, { css } from 'styled-components';

type ImageProps = { size: number };

export const Image = styled.img<ImageProps>(
  props => css`
    margin: 2px;

    ${props.size &&
    css`
      max-width: ${props.size}px;
    `}
  `
);

export const CountryFlag = styled.div`
  display: flex;
  align-items: center;
`;

export const Text = styled.span(
  props => css`
    font-size: 10px;
    color: ${props.theme.text.tertiary};
  `
);
